export default __webpack_public_path__ + "static/media/recording.e2aa146f.svg";